import setupLocalStorageAPI from "./setupLocalStorageAPI";
const FRONTEND_LOG_MODE_KEY = "sunoFrontendLogMode";

export const LOG_MODE_DEBUG = "debug";

export const getLogMode = (featureName?: string) => {
  const logMode = setupLocalStorageAPI(FRONTEND_LOG_MODE_KEY).getData(
    featureName ? { [featureName]: "" } : { common: "" }
  );

  if (!featureName && typeof logMode === "object") {
    return logMode?.common;
  } else if (featureName && typeof logMode === "object") {
    return logMode[featureName];
  }

  return undefined;
};

export const frontendLog = (
  args: any,
  featureName?: string,
  logMode?: string
) => {
  const allLogsMode = getLogMode("all");
  const actualLogMode = getLogMode(featureName);

  const featureLogEnabled =
    (Boolean(actualLogMode) && actualLogMode === logMode) || actualLogMode;

  const allFeaturesLogEnabled =
    (Boolean(allLogsMode) && allLogsMode === logMode) || allLogsMode;

  if (featureLogEnabled || allFeaturesLogEnabled) {
    if (Array.isArray(args) && args[0] && typeof args[0] !== "object") {
      const [, ...rest] = args;
      console.log(`frontendLog.${featureName ?? "common"}.${args[0]}`, rest);
    } else {
      console.log(`frontendLog.${featureName ?? "common"}`, args);
    }
  }
};

/*
1) Usage example:
frontendLog({ helloWrold: true})
frontendLog({ helloWrold: true}, "patient-audiology-report")
frontendLog(["my message",{ helloWrold: true}], "patient-audiology-report")


2) Write this in browser console log to enable frontend log mode

// for a specific feature
localStorage.setItem("sunoFrontendLogMode", JSON.stringify({ patient-audiology-report:"debug" }))

// enable all logs

localStorage.setItem("sunoFrontendLogMode", JSON.stringify({ all:"debug" }))

// remove logs
localStorage.removeItem("sunoFrontendLogMode")
*/
